import './tpl/cart';
import 'swiper/swiper.scss';
import '../scss/main.scss';

//import PerfectScrollbar from 'perfect-scrollbar';
import 'simplebar';

import noUiSlider from 'nouislider';
import smoothscroll from 'smoothscroll-polyfill';
import './tpl/recalculate';
import './tpl/mask';
import './tpl/favorites';
import './tpl/reminder';
import './tpl/validate';
import './tpl/scrollBehavior';
import './tpl/comments';
import './tpl/modalReview';
import './tpl/personal-office/index.js';
//import './tpl/sidebar';

// import '../../js/fixed';
import  Fancybox from "@fancyapps/fancybox/dist/jquery.fancybox.min";


// new SimpleBar(document.getElementById('scrollBar'));

smoothscroll.polyfill();
const changeHeight = (elem) => {
    if (!elem.style.height) {
        elem.style.height = `${elem.scrollHeight}px`;
    } else {
        elem.style.height = null;
    }
};

const sidebarTogger = document.querySelector('.sidebar__toggler');
if (sidebarTogger) {
    sidebarTogger.addEventListener('click', (e) => {
        console.log(e.target.closest('.sidebar__panel').classList);
        e.target.classList.toggle('active');
    });
};

const hiddenToggler = document.querySelector('.hidden__expander');
if (hiddenToggler) {
    hiddenToggler.addEventListener('click', (e) => {
        e.target.closest('.hidden').classList.toggle('active');
    });
};

const mapToggler = document.querySelector('.map__toggler-btn');
if (mapToggler) {
    mapToggler.addEventListener('click', (e) => {
        e.target.closest('.map').classList.toggle('active');
    });
};

const searchHolder = document.querySelector('.header__col_search');
const searchToggler = document.querySelector('.panel__item_search');
searchToggler.addEventListener('click', (e) => {
    if (!searchHolder.style.height) {
        searchHolder.style.height = `${searchHolder.scrollHeight}px`;
    } else {
        searchHolder.style.height = null;
    };
    document.querySelector('.header').scrollIntoView({
        //behavior: 'smooth'
    });
});

const category = document.querySelector('.category');
const posItems = document.querySelectorAll('.pos');
const sortList = document.querySelector('.sort__toggler_list');
const sortTile = document.querySelector('.sort__toggler_tile');
if (sortList && sortTile) {
    sortList.addEventListener('click', (e) => {
        e.target.classList.add('active');
        if (sortTile.classList.contains('active')) {
            sortTile.classList.remove('active')
        }

        if (category.style.display != 'block') {
            category.style.display = 'block';
        }

        posItems.forEach(posItemsEl => {
            if (!posItemsEl.classList.contains('pos_row')) {
                posItemsEl.classList.add('pos_row');
            }
        });
    });

    sortTile.addEventListener('click', (e) => {
        e.target.classList.add('active');
        if (sortList.classList.contains('active')) {
            sortList.classList.remove('active')
        }

        if (category.style.display == 'block') {
            category.removeAttribute('style');
        }

        posItems.forEach(posItemsEl => {
            if (posItemsEl.classList.contains('pos_row')) {
                posItemsEl.classList.remove('pos_row');
            }
        });
    });
};

const sortGrid = document.querySelector('.sort__toggler_grid');
if (sortGrid) {
    sortGrid.addEventListener('click', (e) => {
        e.target.classList.toggle('active');

        if (category.style.display == 'block') {
            category.removeAttribute('style');
        } else {
            category.style.display = 'block';
        }

        posItems.forEach(posItemsEl => {
            if (posItemsEl.classList.contains('pos_row')) {
                posItemsEl.classList.remove('pos_row');
            } else {
                posItemsEl.classList.add('pos_row');
            }
        });
    });
};

const sortSelector = document.querySelector('.sort__selector');
const selectorList = document.querySelector('.sort__selector-list');
const selectorPlaceholder = document.querySelector('.sort__selector-placeholder');
const sortToggler = document.querySelector('.sort__toggler_sort');
if (sortToggler) {
    sortToggler.addEventListener('click', (e) => {
        e.target.classList.toggle('active');
        changeHeight(sortSelector);

        if (selectorList.style.height && sortSelector.classList.contains('active')) {
            selectorList.style.height = null;
            sortSelector.classList.remove('active');
        }
    });
};

if (selectorList && selectorPlaceholder) {
    document.querySelector('.sort__selector-title').addEventListener('click', (e) => {
        e.target.closest('.sort__selector').classList.toggle('active');
        changeHeight(selectorList);
    });

    selectorList.querySelectorAll('input').forEach(selectorListToggler => {
        selectorListToggler.addEventListener('change', (e) => {
            if (e.target.checked) {
                selectorPlaceholder.textContent = e.target.nextElementSibling.textContent;
            }
        });
    });
};

const dropdownTogglers = document.querySelectorAll('.dropdown__toggler');
dropdownTogglers.forEach(dropdownTogglersEl => {
    dropdownTogglersEl.addEventListener('click', (e) => {
        e.target.classList.toggle('active');
        if (!e.target.nextElementSibling.style.display) {
            e.target.nextElementSibling.style.display = 'block';
        } else {
            e.target.nextElementSibling.removeAttribute('style');
        }
    });
});

const minicart = document.querySelector('.minicart');
const minicartClose = document.querySelectorAll('.minicart__toggler_close');
const topmenu = document.querySelector('.topmenu');
const navClose = document.querySelector('.topmenu__toggler_close');
const sidebarPanels = document.querySelectorAll('.sidebar__panel');
const div = document.createElement('div');
const minicartRemove = document.querySelector('.minicart__close');
document.body.addEventListener('click', (e) => {
    switch (e.target.classList.contains('sort__toggler_btn')) {
        case true:
            document.body.classList.add('overflow-hidden');
            document.querySelector(`.${e.target.getAttribute('data-target')}`).classList.add('active');
            sidebarPanels.forEach(sidebarPanelsEl => {
                if (sidebarPanelsEl.classList.contains('active') && !sidebarPanelsEl.classList.contains(e.target.getAttribute('data-target'))) {
                    sidebarPanelsEl.classList.remove('active');
                }
            });
            break;

        case false:
            if (!e.target.closest('.sidebar__title') && !e.target.closest('.sidebar__wrapper')) {
                document.body.classList.remove('overflow-hidden');
                sidebarPanels.forEach(sidebarPanelsEl => {
                    if (sidebarPanelsEl.classList.contains('active')) {
                        sidebarPanelsEl.classList.remove('active');
                    }
                });
            }
            if (e.target.classList.contains('sidebar__close')) {
                document.body.classList.remove('overflow-hidden');
                e.target.closest('.sidebar__panel').classList.remove('active');
            }
            break;
    }

    switch (e.target.classList.contains('header__toggler_nav')) {
        case true:
            document.body.classList.toggle('topmenu-open');
            changeHeight(topmenu);
            break;

        case false:
            if (!e.target.closest('.topmenu') || e.target == navClose) {
                document.body.classList.remove('topmenu-open');
                topmenu.style.height = null;
            }
            break;
    }

    switch (e.target.classList.contains('header__link_cart') || e.target.classList.contains('panel__item_cart')) {
        case true:
            //minicart.classList.add('minicart-open');
            document.body.classList.add('minicart-open');
            div.classList.add('minicart-overaly');
            document.body.appendChild(div);
            break;

        case false:
            if (!e.target.closest('.minicart')) {
                document.body.classList.remove('minicart-open');
                div.classList.remove('minicart-overaly');
            }

            case false:
                if (e.target.classList.contains('minicart__toggler_close') || e.target == minicartClose) {
                    document.body.classList.remove('minicart-open');
                    //minicart.classList.remove('minicart-open');
                    div.classList.remove('minicart-overaly');
                }

                break;
    }
});


const filter = document.querySelector('.filter__slider');
const filterFields = [document.querySelector('#filter-min'), document.querySelector('#filter-max')];
if (filter) {
    noUiSlider.create(filter, {
        start: [0, 20000],
        step: 100,
        connect: true,
        tooltips: false,
        range: {
            'min': [0],
            'max': [50000]
        },
        format: wNumb({
            decimals: 0,
            //suffix: ' ₽'
        })
    });

    filter.noUiSlider.on('update', (values, handle) => {
        filterFields[handle].value = values[handle];
    });

    filterFields.forEach((input, handle) => {
        input.addEventListener('change', (e) => {
            filter.noUiSlider.setHandle(handle, e.target.value);
        });

        input.addEventListener('keydown', (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
            let values = filter.noUiSlider.get();
            let value = Number(values[handle]);

            let steps = filter.noUiSlider.steps();
            let step = steps[handle];

            let position;

            switch (e.which) {
                case 13:
                    filter.noUiSlider.setHandle(handle, e.target.value);
                    break;

                case 38:
                    position = step[1];
                    if (position === false) {
                        position = 1;
                    }
                    if (position !== null) {
                        filter.noUiSlider.setHandle(handle, value + position);
                    }
                    break;

                case 40:
                    position = step[0];
                    if (position === false) {
                        position = 1;
                    }
                    if (position !== null) {
                        filter.noUiSlider.setHandle(handle, value - position);
                    }
                    break;
            }
        });
    });
}

document.querySelector('.minicart__close').addEventListener('click', (e) => {
    document.body.classList.remove('minicart-open');
    div.classList.remove('minicart-overaly');
});

window.addEventListener('scroll', () => {
    if (window.pageYOffset > 0.2 * document.body.scrollHeight) {
        document.querySelector('.page-btn_up').classList.add('active');
    } else {
        document.querySelector('.page-btn_up').classList.remove('active');
    };
});

document.querySelector('.page-btn_up').addEventListener('click', (e) => {
    document.querySelector('.page').scrollIntoView({
        behavior: 'smooth'
    });
});

document.querySelectorAll('.page-anchor').forEach(pageAnchor => {
    pageAnchor.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector(e.target.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

//document.querySelectorAll('.cart_minicart').forEach(miniCart => {
//	new PerfectScrollbar(miniCart);
//});

//const ps = new
//PerfectScrollbar('.cart_minicart', {
//wheelSpeed: 2,
//wheelPropagation: true,
// minScrollbarLength: 20,
//  suppressScrollY: false
//});
//const psClass = document.querySelector('.cart_minicart');
//psClass.classList.add('ps--active-y');


if (document.querySelector('.cart__btn_finalize')) {
    document.querySelector('.cart__btn_finalize').addEventListener('click', (e) => {
        document.querySelector('.checkout').scrollIntoView({
            behavior: 'smooth'
        });
    });
}
const accordions = document.querySelectorAll('.accordion-js');

const accordions_noclose = document.querySelectorAll('.no-close');

accordions.forEach(el => {
    el.addEventListener('click', (e) => {
        const self = e.currentTarget;
        const control = self.querySelector('.accordion__header-js');
        const content = self.querySelector('.accordion__body');

        
        self.classList.toggle('active');

        // если открыт аккордеон
        if (self.classList.contains('active')) {
            control.setAttribute('aria-expanded', true);
            content.setAttribute('aria-hidden', false);
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {

            control.setAttribute('aria-expanded', false);
            content.setAttribute('aria-hidden', true);
            content.style.maxHeight = null;
        }
    });
});
accordions_noclose.forEach(el => {
    el.addEventListener('click', (e) => {
        const self = e.currentTarget;
        const control = self.querySelector('.accordion__header-js');
        const content = self.querySelector('.accordion__body');

        
        self.classList.toggle('active'); 

        // если открыт аккордеон
        if (self.classList.contains('active')) {
            control.setAttribute('aria-expanded', true);
            content.setAttribute('aria-hidden', false);
            content.style.maxHeight = content.scrollHeight + 'px';
        } 
    });
});


// $('.order__page_content-row').on('click touchstart', function (e) {
//     e.preventDefault();
//     return false;
// });

$('#edit').click(function () {
    $("input").removeAttr("readonly");
    $('#edit').hide();
    $('#save').show();
});

$('#save').click(function () {
    $("input").attr("readonly", 'true');
    $('#save').hide();
    $('#edit').show();
});

//const btnEdit = document.getElementById('#edit');
//for (var i = 0; i < btnEdit.length; i++) {
//  btnEdit[i].onclick = function(event) {	
//    event.preventDefault;
//  this.parentElement.querySelector('input').readOnly = false;
//}
//}

//Fancy box 
new Swiper('.swiper-container_col4', {
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-btn_next',
        prevEl: '.swiper-btn_prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
        1366: {
            slidesPerView: 4,
        }
    }
});

new Swiper('.swiper-container_carousel', {
    slidesPerView: 'auto',
    navigation: {
        nextEl: '.swiper-btn_next',
        prevEl: '.swiper-btn_prev',
    },
});

/* pos */
const posGalleryThumbs = new Swiper('.swiper-container_thumbs', {
    centeredSlides: true,
    // centeredSlidesBounds: true,
    slidesPerView: 3,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,

    breakpoints: {
        320: {
            direction: 'horizontal'
        },
        768: {
            direction: 'vertical'
        }
    },

    navigation: {
        nextEl: '.swiper-btn_next4',
        prevEl: '.swiper-btn_prev4',
    },

});

const posGalleryMain = new Swiper('.swiper-container_main', {
    slidesPerView: 1,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    thumbs: {
        swiper: posGalleryThumbs
    }
});

// posGalleryMain.on('slideChange', () => {
//     console.log(posGalleryMain.activeIndex);
// });

posGalleryMain.on('slideChangeTransitionStart', () => {
    posGalleryThumbs.slideTo(posGalleryMain.activeIndex);
});

posGalleryThumbs.on('transitionStart', () => {
    posGalleryMain.slideTo(posGalleryThumbs.activeIndex);
});

$('[data-fancybox="gallery"]').fancybox({
    afterShow: function (instance, current) {
        posGalleryThumbs.slideTo(instance.currIndex);
    }
});


// Fancybox.bind('[data-fancybox]', {
//     // Your custom options
//   });

/// loupe
(function ($) {
        $.fn.loupe = function (arg) {
            var options = $.extend({
                loupe: 'loupe',
                width: 200,
                height: 150
            }, arg || {});

            return this.length ? this.each(function () {
                var $this = $(this),
                    $big, $loupe,
                    $small = $this.is('img') ? $this : $this.find('img:first'),
                    move, hide = function () {
                        $loupe.hide();
                    },
                    time;

                if ($this.data('loupe') != null) {
                    return $this.data('loupe', arg);
                }

                move = function (e) {
                    var os = $small.offset(),
                        sW = $small.outerWidth(),
                        sH = $small.outerHeight(),
                        oW = options.width / 2,
                        oH = options.height / 2;

                    if (!$this.data('loupe') ||
                        e.pageX > sW + os.left + 0 || e.pageX < os.left - 0 ||
                        e.pageY > sH + os.top + 0 || e.pageY < os.top - 0) {
                        return hide();
                    }

                    time = time ? clearTimeout(time) : 0;

                    $loupe.show().css({
                        left: e.pageX - oW,
                        top: e.pageY - oH
                    });
                    $big.css({
                        left: -(((e.pageX - os.left) / sW) * $big.width() - oW) | 0,
                        top: -(((e.pageY - os.top) / sH) * $big.height() - oH) | 0
                    });
                };

                $loupe = $('<div />')
                    .addClass(options.loupe)
                    .css({
                        width: options.width,
                        height: options.height,
                        position: 'absolute',
                        overflow: 'hidden',
                        cursor: 'zoom-in'
                    })
                $loupe = $('<a />')
                    .addClass(options.loupe)
                    .css({
                        width: options.width,
                        height: options.height,
                        position: 'absolute',
                        overflow: 'hidden',
                        cursor: 'zoom-in'
                    })
                    .append($big = $('<img />').attr('src', $this.attr($this.is('img') ? 'src' : 'href')).css('position', 'absolute'))
                    .mousemove(move)
                    .hide()
                    .appendTo('body');

                $this.data('loupe', true)
                    .mouseenter(move)
                    .mouseout(function () {
                        time = setTimeout(hide, 10);
                    });
            }) : this;
        };
    }


    (jQuery));
$('.loupe-active').loupe({
    width: 200, // ширина лупы
    height: 100, // высота лупы
    loupe: 'loupe', // css класс лупы
    magnify: 10

});





    /* Закрытие всплывающего окна на ознакомление с куки */
    $('#cookie-close').on('click', (evt) => {
        var date = new Date;
        date.setDate(date.getDate() + 7);
        date = date.toUTCString();
        document.cookie = 'NOCOOKIETEXT=1; path=/; expires='+date;

        $('.cookie-block').slideToggle();
    });